import {
  ADD_TASK_TO_TASKLIST,
  REMOVE_TASK_FROM_TASKLIST,
  UPDATE_TASK_IN_TASKLIST,
  SET_TASK_LIST
} from "../constants/actionTypes";

const initialState = [];

const TaskList = (state = initialState, action) => {
  switch (action.type) {
    case SET_TASK_LIST:
      return action.payload;
    case ADD_TASK_TO_TASKLIST:
      return [...state, action.payload];
    case REMOVE_TASK_FROM_TASKLIST:
      return [...state].filter(
        (stateItem, itemIndex) => stateItem.Id !== action.payload
      );
    case UPDATE_TASK_IN_TASKLIST:
      return [...state].map((stateItem, itemIndex) => {
        if (itemIndex !== action.index) {
          return stateItem;
        } else {
          return action.payload;
        }
      });
    default:
      return state;
  }
};

export default TaskList;
